import {  Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from 'ng-formly';
import { LoopBackFilter } from '../../sdk/models/';
import * as _ from "lodash";
import { evalExpression } from 'ng-formly/src/core/utils';
import { LoopBackAuth } from '../../sdk/services/core/auth.service';
import { PlatformApp } from '../../services/app.service';
import { CacheService } from 'ng2-cache/ng2-cache';
import {
	AccountApi,
	ActivityApi,
	AggregatesApi,
	AppApi,
	ApptypeApi,
	ChartApi,
	CurrencyApi,
	DashboardApi,
	DataelementApi,
	EntityApi,
	EntitycompactlayoutApi,
	EntityfieldApi,
	EntitylistlayoutApi,
	EntitypagelayoutApi,
	EntityrecordApi,
	EntityrecordhistoryApi,
	EntitysearchlayoutApi,
	InstallationApi,
	MenuitemApi,
	NoteApi,
	NotificationApi,
	PaastenantApi,
	PicklistApi,
	ProfileApi,
	ReportdownloadApi,
	ReporttemplateApi,
	TenantApi
} from '../../sdk/services/custom';
import 'rxjs/add/operator/takeUntil';
import { Subject } from 'rxjs/Subject';


// @Component({
//   selector: 'formly-picklist-radio',
//   template: `
//   <div class="btn-group">
//       <div *ngFor="let option of to.options">
//           <label class="btn btn-primary" [(ngModel)]="value" btnRadio="option.value">
//           <input [id]="id" [name]="id" 
//           [value]="option.value" 
//           [formControl]="formControl" 
//           [formlyAttributes]="field">{{option.label}}</label>
//       </div>
//   </div>
//   `,
// })

// @Component({
//   selector: 'formly-picklist-radio',
//   template: `
//     <div [formGroup]="form" class="col-sm-12">
//       <div *ngFor="let option of to.options" class="radio">
//         <label class="custom-control custom-radio col-sm-2" >
//           <input [id]="id" [name]="id" type="radio" [value]="option.value" [formControl]="formControl"
//           [formlyAttributes]="field" class="custom-control-input">
//           {{option.label}}
//           <span class="custom-control-indicator"></span>
//         </label>
//       </div>
//     </div>
//   `,
// })

// @Component({
//   selector: 'formly-picklist-radio',
//   template: `
// <a *ngIf="required" > <font color="red" > * </font></a>
// 	<div[formGroup]="form" >
// 		<div *ngFor="let option of items" class="radio" >
// 			<label class="btn btn-secondary pull-left col-sm-3" >
// 				<input[id]="id"[name] = "id" type= "radio"[value] = "option.value"[formControl] = "formControl"
// 				[formlyAttributes] = "field" class="custom-control-input" >
// 					{{option.label }}
// </label>
// 	< /div>
// 	< /div>
//   `,
// })

@Component({
	selector: 'formly-picklist-radio',
	template: `
    <div [formGroup]="form" class="col-sm-12">
      <div *ngFor="let option of items" class="radio">
        <label class="custom-control custom-radio col-sm-2" >
          <input [id]="id" [name]="id" type="radio" [value]="option.value" [formControl]="formControl"
          [formlyAttributes]="field" class="custom-control-input">
          {{option.label}}
          <span class="custom-control-indicator"></span>
        </label>
      </div>
    </div>
  `,
	providers: [
		AccountApi,
		ActivityApi,
		AggregatesApi,
		AppApi,
		ApptypeApi,
		ChartApi,
		CurrencyApi,
		DashboardApi,
		DataelementApi,
		EntityApi,
		EntitycompactlayoutApi,
		EntityfieldApi,
		EntitylistlayoutApi,
		EntitypagelayoutApi,
		EntityrecordApi,
		EntityrecordhistoryApi,
		EntitysearchlayoutApi,
		InstallationApi,
		MenuitemApi,
		NoteApi,
		NotificationApi,
		PaastenantApi,
		PicklistApi,
		ProfileApi,
		ReportdownloadApi,
		ReporttemplateApi,
		TenantApi
	]
})

export class PicklistRadio extends FieldType implements OnInit, OnDestroy {

	_loopbackfilter: LoopBackFilter = <LoopBackFilter>{};
	items: any = [];
	selectedvalues: any = [];
	currentuser;
	appId;
	value: any = {};
	formulae = [];
	modelValues = [];
	apiData = false;
	ngUnsubscribe: Subject<void> = new Subject<void>();

	get type() {
		return this.to.type || null;
	}

	get readonly() {
		return this.to.readonly || false;
	}

	get required() {
		return this.to.required || false;
	}

	get multiple() {
		return this.to.multiple || false;
	}

	get entityrecord() {
		return (this.to.type == 'entityrecord' ? true : false);
	}

	constructor(
		private _CacheService: CacheService,
		private _AccountApi: AccountApi,
		private _ActivityApi: ActivityApi,
		private _AggregatesApi: AggregatesApi,
		private _AppApi: AppApi,
		private _ApptypeApi: ApptypeApi,
		private _ChartApi: ChartApi,
		private _CurrencyApi: CurrencyApi,
		private _DashboardApi: DashboardApi,
		private _DataelementApi: DataelementApi,
		private _EntityApi: EntityApi,
		private _EntitycompactlayoutApi: EntitycompactlayoutApi,
		private _EntityfieldApi: EntityfieldApi,
		private _EntitylistlayoutApi: EntitylistlayoutApi,
		private _EntitypagelayoutApi: EntitypagelayoutApi,
		private _EntityrecordApi: EntityrecordApi,
		private _EntityrecordhistoryApi: EntityrecordhistoryApi,
		private _EntitysearchlayoutApi: EntitysearchlayoutApi,
		private _InstallationApi: InstallationApi,
		private _MenuitemApi: MenuitemApi,
		private _NoteApi: NoteApi,
		private _NotificationApi: NotificationApi,
		private _PaastenantApi: PaastenantApi,
		private _PicklistApi: PicklistApi,
		private _ProfileApi: ProfileApi,
		private _ReportdownloadApi: ReportdownloadApi,
		private _ReporttemplateApi: ReporttemplateApi,
		private _TenantApi: TenantApi,
		private _LoopBackAuth: LoopBackAuth,
		private _PlatformApp: PlatformApp) {
		super();
	}

	ngOnInit() {
		if (!this.form['selectoptions'])
			this.form['selectoptions'] = {};

		if (!this.form['subscriptions'])
			this.form['subscriptions'] = [];

		if (!this.form['newcontrols'])
			this.form['newcontrols'] = {};

		for (var key in this.form.controls)
			this.form['newcontrols'][key] = this.form.controls[key];

		if (this.field['formulae']) {
			this.formulae = this.field['formulae'];
			if (this.field.formControl)
				this.addWatcher(this.field.formControl);
		}

		if (this.field['validate']) {
			this.to.operation = this.field['validate']['operation'];
			this.to.checkerfield = this.field['validate']['field'];
			this.addValidateWatcher(this.field.formControl);
		}

		if (this.to.readonly)
			this.to.disabled = true;

		if (this.field.defaultValue && !this.model[this.key])
			this.formControl.setValue(this.field.defaultValue);

		if (this.model[this.key]) {
			this.formControl.setValue(this.model[this.key]);
			this.processFormulae(this.model[this.key]);
		}

		this.currentuser = this._LoopBackAuth.getCurrentUserData();
		if (PlatformApp.getAppVariable("platformApp"))
			this.appId = PlatformApp.getAppVariable("referenceAppId");
		else
			this.appId = this.currentuser.appId;

		if (this.to.type && (this.to.type == 'filtercondition' || this.to.type == 'filtervalue')) {
			this.form['subscriptions'].push(this.form.controls[this.to.filter].valueChanges
				.subscribe((updatedValue: any) => {
					if (updatedValue) {
						let formField = this.getFormField(updatedValue, this.model['dataFields']);
						if (formField) {
							this.constructFilterOptions(formField);
							this.refreshOptions();
						}
						else
							console.log('Missing FormField for : ' + updatedValue);
					}
				}));
		}

		if (this.field['parentLookupField'] && this.field['parentLookupDataField']) {
			this.apiData = true;
			if (this.model && this.model[this.field["parentLookupField"]])
				this.pullLookupData(this.model[this.field["parentLookupField"]]);
			this.setNewFormControl(this.field['parentLookupField']);
			if (this.form.controls[this.field["parentLookupField"]])
				this.form['subscriptions'].push(this.form.controls[this.field["parentLookupField"]].valueChanges
					.subscribe((parentLookupFieldValue: any) => {
						this.pullLookupData(parentLookupFieldValue);
					}));
			this.setNewFormControl(this.key);
			if (this.form.controls[this.key])
				this.form['subscriptions'].push(this.form.controls[this.key].valueChanges
					.subscribe((currentValue: any) => {
						this.refreshOptions();
					}));
		}

		this.refreshOptions();
	}

	private refreshOptions() {

		// Set to.type as the DataSource Name to pull Data
		// To use this Switch Case option for General Select
		// Setup the to.type as null
		this._loopbackfilter.where = {};
		switch (this.to.type) {
			case 'account':
				this.setApiValues(this._AccountApi, 'id', 'email');
				break;

			case 'activity':
				this.setApiValues(this._ActivityApi, 'id', 'name');
				break;

			case 'aggregates':
				this.setApiValues(this._AggregatesApi, 'id', 'name');
				break;

			case 'app':
				this.field.templateOptions['parentFieldName'] = this.getValue(this.field, 'parentFieldName');
				if (this.field['parentFieldName'] && this.form.controls[this.field['parentFieldName']]) {

					this.form['subscriptions'].push(this.form.controls[this.field['parentFieldName']].valueChanges
						.subscribe((updatedValue: any) => {
							if (updatedValue) {
								this._loopbackfilter.where = {};
								this._loopbackfilter.where['appId'] = this.appId;
								this._loopbackfilter.where['entityId'] = this.field['lookupfield'];
								this._loopbackfilter.where['data.' + this.field['parentFieldLookupName']] = updatedValue;
								this.setApiValues(this._AppApi, 'id', 'name');
							}
						}));
				}
				this.setApiValues(this._AppApi, 'id', 'name');
				break;

			case 'apptype':
				this.setApiValues(this._ApptypeApi, 'id', 'name');
				break;

			case 'chart':
				this.setApiValues(this._ChartApi, 'id', 'label');
				break;

			case 'currency':
				this.setApiValues(this._CurrencyApi, 'id', 'name');
				break;

			case 'dashboard':
				//check if platform and load accordingly	
				if (this.appId.toString() === "582d93938361b48c1f7b0c9d" && this.model.id)
					this._loopbackfilter.where['appId'] = this.model.id;
				else
					this._loopbackfilter.where['appId'] = this.appId;

				this.setApiValues(this._DashboardApi, 'id', 'name');
				break;

			case 'dataelement':
				this._loopbackfilter.where['appId'] = this.appId;

				this.setApiValues(this._DataelementApi, 'id', 'name');
				break;

			case 'entity':
				this._loopbackfilter.where['appId'] = this.appId;
				this.field['parentId'] = this.getValue(this.field, 'parentId');
				if (this.field["parentId"])
					this._loopbackfilter.where = { parentId: this.field['parentId'] };

				this.setApiValues(this._EntityApi, 'id', 'label');
				break;

			case 'entitycompactlayout':
				//check if platform and load accordingly	
				if (this.appId.toString() === "582d93938361b48c1f7b0c9d" && this.model.id)
					this._loopbackfilter.where['appId'] = this.model.id;
				else
					this._loopbackfilter.where['appId'] = this.appId;

				this.setApiValues(this._EntitycompactlayoutApi, 'id', 'name');
				break;

			case 'entityfield':

				if (this.field.templateOptions['parent']) {
					this.setNewFormControl(this.field.templateOptions['parent']);
					if (this.form.controls[this.field.templateOptions['parent']])
						this.form['subscriptions'].push(this.form.controls[this.field.templateOptions['parent']].valueChanges
							.subscribe((updatedValue: any) => {
								if (updatedValue) {
									this._loopbackfilter.where = {};
									this._loopbackfilter.where['appId'] = this.appId;
									this._loopbackfilter.where['entityId'] = updatedValue;

									if (this.field.templateOptions['savenames'])
										this.setApiValues(this._EntityfieldApi, 'name', 'label');
									else
										this.setApiValues(this._EntityfieldApi, 'id', 'label');
								}
							}));
				}

				this.field['parentEntity'] = this.getValue(this.field, 'parentEntity');
				if (!this.field['parentEntity'])
					if (this.field.templateOptions['parent'] && this.model[this.field.templateOptions['parent']])
						this.field['parentEntity'] = this.model[this.field.templateOptions['parent']];
					else if (this.model.entityId)
						this.field['parentEntity'] = this.model.entityId;
					else if (this.model.id)
						this.field['parentEntity'] = this.model.id;

				if (this.field["parentEntity"]) {
					this._loopbackfilter.where['entityId'] = this.field['parentEntity'];
					this._loopbackfilter.where['appId'] = this.appId;
					if (this.field.templateOptions["savenames"])
						this.setApiValues(this._EntityfieldApi, 'name', 'label');
					else
						this.setApiValues(this._EntityfieldApi, 'id', 'label');
				}
				else
					console.log('EntityField ' + this.key + ' has no Parent Entity tagged ');
				break;

			case 'entitylistlayout':
				//check if platform and load accordingly	
				if (this.appId.toString() === "582d93938361b48c1f7b0c9d" && this.model.id)
					this._loopbackfilter.where['appId'] = this.model.id;
				else
					this._loopbackfilter.where['appId'] = this.appId;

				this.setApiValues(this._EntitylistlayoutApi, 'id', 'label');
				break;

			case 'entitypagelayout':
				//check if platform and load accordingly	
				if (this.appId.toString() === "582d93938361b48c1f7b0c9d" && this.model.id)
					this._loopbackfilter.where['appId'] = this.model.id;
				else
					this._loopbackfilter.where['appId'] = this.appId;

				this.setApiValues(this._EntitypagelayoutApi, 'id', 'label');
				break;

			case 'entityrecord':
				this._loopbackfilter.where['appId'] = this.appId;

				this.field['lookupfield'] = this.getValue(this.field, 'lookupfield');
				this.field['lookupfieldname'] = this.getValue(this.field, 'lookupfieldname');
				if (this.field['lookupfield'])
					this._loopbackfilter.where['entityId'] = this.field['lookupfield'];

				// Parent Entity Field
				this.field['parentEntityFieldName'] = this.getValue(this.field, 'parentEntityFieldName');
				this.setNewFormControl(this.field['parentEntityFieldName']);
				if (this.field['parentEntityFieldName'] && this.form.controls[this.field['parentEntityFieldName']]) {
					this.form['subscriptions'].push(this.form.controls[this.field['parentEntityFieldName']].valueChanges
						.subscribe((updatedValue: any) => {
							if (updatedValue) {
								//Get the field from the CacheService
								var field = _.find(this._CacheService.get('formfields'), { 'key': updatedValue });
								if (field['lookupfield'] && field['lookupfieldname']) {
									this.field['lookupfield'] = this.getValue(field, 'lookupfield');
									this.field['lookupfieldname'] = this.getValue(field, 'lookupfieldname');

									this._loopbackfilter.where = {};
									this._loopbackfilter.where['appId'] = this.appId;
									this._loopbackfilter.where['entityId'] = this.field['lookupfield'];
									this.setApiValues(this._EntityrecordApi, 'id', this.field['lookupfieldname'], '', 'data.');
								}
							}
						}));
				}

				// Cascaded Lookup
				this.field['cascaded'] = this.getValue(this.field, 'cascaded');
				this.field['parentFieldName'] = this.getValue(this.field, 'parentFieldName');
				if (this.field['cascaded'] && this.field['parentFieldName'] && this.form.controls[this.field['parentFieldName']]) {
					this.form['subscriptions'].push(this.form.controls[this.field['parentFieldName']].valueChanges
						.subscribe((updatedValue: any) => {
							if (updatedValue && this.field['parentFieldLookupName']) {
								this._loopbackfilter.where = {};
								this._loopbackfilter.where['appId'] = this.appId;
								this._loopbackfilter.where['entityId'] = this.field['lookupfield'];
								this._loopbackfilter.where['data.' + this.field['parentFieldLookupName']] = updatedValue;
								this.setApiValues(this._EntityrecordApi, 'id', this.field['lookupfieldname'], '', 'data');
							}
						}));
				}

				if (this.field['cascaded'] && this.field['parentFieldName'] && this.field['parentFieldLookupName'])
					this._loopbackfilter.where['data.' + this.field['parentFieldLookupName']] = this.model[this.field['parentFieldName']];

				this.setApiValues(this._EntityrecordApi, 'id', this.field['lookupfieldname'], '', 'data');
				break;

			case 'entityrecordhistory':
				this._loopbackfilter.where['appId'] = this.appId;

				this.setApiValues(this._EntityrecordhistoryApi, 'id', 'name');
				break;

			case 'entitysearchlayout':
				//check if platform and load accordingly	
				if (this.appId.toString() === "582d93938361b48c1f7b0c9d" && this.model.id)
					this._loopbackfilter.where['appId'] = this.model.id;
				else
					this._loopbackfilter.where['appId'] = this.appId;

				this.setApiValues(this._EntitysearchlayoutApi, 'id', 'label');
				break;

			case 'installation':
				this.setApiValues(this._InstallationApi, 'id', 'name');
				break;

			case 'menuitem':
				this._loopbackfilter.where['appId'] = this.appId;

				this.field['lookupfield'] = this.getValue(this.field, 'lookupfield');
				if (this.field['lookupfield']) {
					this.form['subscriptions'].push(this._MenuitemApi.findById(this.field['lookupfield'])
						.subscribe((menuitem) => {
							if (menuitem && menuitem['submenu']) {
								this.to.options = menuitem['submenu'];
								this.setOptionValues('link', 'label');
								this.apiData = true;
							} else {
								this.items = [];
								this.selectedvalues = [];
							}
						}));
				}
				else if (this.to.options && this.to.options.length && this.to.options.length > 0) {
					this.setOptionValues('link', 'label');
					this.apiData = true;
				}
				else
					this.setApiValues(this._MenuitemApi, 'link', 'label');

				break;

			case 'note':
				this._loopbackfilter.where['appId'] = this.appId;

				this.setApiValues(this._NoteApi, 'id', 'name');
				break;

			case 'notification':
				this._loopbackfilter.where['appId'] = this.appId;

				this.setApiValues(this._NotificationApi, 'id', 'name');
				break;

			case 'paastenant':
				this.setApiValues(this._PaastenantApi, 'id', 'name');
				break;

			case 'picklist':
				this._loopbackfilter.where['appId'] = this.appId;

				this.field['lookupfield'] = this.getValue(this.field, 'lookupfield');
				if (this.field['lookupfield'] && this.to.subtype && this.to.subtype == 'global') {
					this.form['subscriptions'].push(this._PicklistApi.findById(this.field['lookupfield'])
						.subscribe((picklist) => {
							if (picklist && picklist['options']) {
								this.to.options = picklist['options'];
								this.setOptionValues('value', 'label');
							} else {
								this.items = [];
								this.selectedvalues = [];
							}
						}));
				}
				else if (this.field['lookupfield'] && this.to.subtype && this.to.subtype == 'dataelement') {
					var filter: LoopBackFilter = <LoopBackFilter>{};
					filter['data'] = true;
					var filterfields = {};
					if (this.to.dataelementfilter && this.to.dataelementfilter.length) {
						for (var index = 0; index < this.to.dataelementfilter.length; index++) {
							var element = this.to.dataelementfilter[index];
							if (element.filtername && element.filterfield) {
								filterfields[element.filterfield] = element.filtername;
								if (this.model[element.filterfield])
									filter[element.filtername] = this.model[element.filterfield]
							}
						}
					}
					this.form['subscriptions'].push(this._DataelementApi.findById(this.field['lookupfield'], filter)
						.subscribe((dataelement) => {
							if (dataelement && dataelement['data']) {
								this.to.options = dataelement['data'];
								this.setOptionValues('value', 'label');
							} else {
								this.items = [];
								this.selectedvalues = [];
							}
						}));

					for (var key in filterfields) {
						this.setNewFormControl(key);
						if (this.form.controls[key]) {
							this.form['subscriptions'].push(this.form.controls[key].valueChanges
								.subscribe((updatedValue: any) => {
									if (updatedValue) {
										filter[filterfields[key]] = updatedValue;
										this.form['subscriptions'].push(this._DataelementApi.findById(this.field['lookupfield'], filter)
											.subscribe((dataelement) => {
												if (dataelement && dataelement['data']) {
													this.to.options = dataelement['data'];
													this.setOptionValues('value', 'label');
												} else {
													this.items = [];
													this.selectedvalues = [];
												}
											}));
									}
								}));
						}
					}
				}
				else if (this.to.options && this.to.options.length && this.to.options.length > 0) {
					this.setOptionValues('value', 'label');
				}
				else
					this.setApiValues(this._PicklistApi, 'id', 'label');
				break;

			case 'profile':
				this._loopbackfilter.where['appId'] = this.appId;

				this.setApiValues(this._ProfileApi, 'id', 'name');
				break;

			case 'reportdownload':
				this._loopbackfilter.where['appId'] = this.appId;

				this.setApiValues(this._ReportdownloadApi, 'id', 'name');
				break;

			case 'reporttemplate':
				this._loopbackfilter.where['appId'] = this.appId;

				this.setApiValues(this._ReporttemplateApi, 'id', 'name');
				break;

			case 'tenant':
				this.setApiValues(this._TenantApi, 'id', 'name');
				break;

			case 'filterfield':
				this.to.options = this.getFilterSelectOptions(this.model.dataFields);
				this.setOptionValues('value', 'label');
				break;

			case 'filtercondition':
				if (this.model.filterConditionOptions) {
					this.to.options = this.model.filterConditionOptions;

					this.setOptionValues('value', 'label');
				}
				break;

			case 'filtervalue':
				if (this.model['filterValueOptions']) {
					// this.field['cascaded'] = this.model['cascaded'];
					this.field['lookupfield'] = this.model['lookupfield'];
					this.field['lookupfieldname'] = this.model['lookupfieldname'];
					this.field['parentFieldName'] = this.model['parentFieldName'];
					this.field['parentFieldLookupName'] = this.model['parentFieldLookupName'];
					this.field['parentEntityFieldName'] = this.model['parentEntityFieldName'];
					this.to.type = this.model['filterValueType'];
					this.to.options = this.model['filterValueOptions'];
					this.to.label = this.model['filterValueLabel'];

					this.refreshOptions();
				}
				break;

			default:
				this.setOptionValues('value', 'label');
				break;
		}
		this.setFieldState();
	}

	private setApiValues(currentApi, idFieldName?: string, textFieldName?: string, idFieldParent?: string, textFieldParent?: string) {
		this.items = [];
		this.selectedvalues = [];

		if (!idFieldName) idFieldName = 'id';
		if (!textFieldName) textFieldName = 'name';
		this.setFieldState();
		this.apiData = true;

		this.form['subscriptions'].push(currentApi.find(this._loopbackfilter)
			.subscribe((results) => {
				if (results && results.length && results.length > 0) {
					results.forEach((result) => {
						let idValue: any;
						let textValue: any;

						if (idFieldParent) idValue = result[idFieldParent][idFieldName];
						else idValue = result[idFieldName];

						if (textFieldParent) textValue = result[textFieldParent][textFieldName];
						else textValue = result[textFieldName];

						if (this.to.type == 'entityfield' && result['name'])
							textValue = textValue + ' > ' + result['name'];

						this.items.push({ id: idValue, text: textValue });

						if (this.multiple && this.model[this.key] && this.model[this.key].indexOf(idValue) > -1)
							this.selectedvalues[this.model[this.key].indexOf(idValue)] = { id: idValue, text: textValue };

						if (!this.multiple && this.model[this.key] && this.model[this.key] == idValue)
							this.selectedvalues = [{ id: idValue, text: textValue }];
					});
				} else {
					this.items = [];
					this.selectedvalues = [];
				}
				this.setFieldState();
			}));

	}

	private setOptionValues(idFieldName?: string, textFieldName?: string) {
		this.items = [];
		this.selectedvalues = [];

		if (!idFieldName) idFieldName = 'value';
		if (!textFieldName) textFieldName = 'label';
		this.apiData = false;

		if (this.to.options && this.to.options.length && this.to.options.length > 0) {
			this.to.options.forEach((option) => {
				this.items.push({ id: option[idFieldName], text: option[textFieldName] });

				if (this.multiple && this.model[this.key] && this.model[this.key].indexOf(option[idFieldName]) > -1)
					this.selectedvalues[this.model[this.key].indexOf(option[idFieldName])] = { id: option[idFieldName], text: option[textFieldName] };

				if (!this.multiple && this.model[this.key] && this.model[this.key] == option[idFieldName])
					this.selectedvalues = [{ id: option[idFieldName], text: option[textFieldName] }];
			});
		}
		this.setFieldState();
	}

	private setFieldState() {
		if (this.items && this.items.length && this.items.length > 0) {
			this.items = _.map(_.groupBy(this.items, function (element) {
				return element['id'];
			}), function (grouped) {
				return grouped[0];
			});
			this.items = _.uniq(_.sortBy(this.items, 'text'));
			this.field.templateOptions.disabled = false;
		} else
			this.field.templateOptions.disabled = true;

		if (this.model[this.key])
			if (this.items && this.items.length && this.items.length > 0)
				if (this.selectedvalues && this.selectedvalues.length && this.selectedvalues.length == 0)
					delete this.model[this.key];
	}

	private pullLookupData(parentLookupFieldValue) {
		if (parentLookupFieldValue)
			this.form['subscriptions'].push(this._EntityrecordApi.findById(parentLookupFieldValue)
				.subscribe((record) => {
					if (record && record['data'] && record['data'][this.field['parentLookupDataField']])
						this.formControl.setValue(record['data'][this.field['parentLookupDataField']]);
				}));
	}

	private addValidateWatcher(formControl) {
		if (this.model && this.model[this.key] && this.model[this.to.checkerfield])
			if (!(PlatformApp.validateValue(this.model[this.key], this.model[this.to.checkerfield], this.to.operation)))
				this.setFormError('validateError');
		if (this.field.formControl)
			this.form['subscriptions'].push(formControl.valueChanges
				.subscribe((updatedValue: any) => {
					if (this.model && this.model[this.to.checkerfield])
						if (!(PlatformApp.validateValue(updatedValue, this.model[this.to.checkerfield], this.to.operation)))
							this.setFormError('validateError');
				}));
		this.setNewFormControl(this.to.checkerfield);
		if (this.form.controls[this.to.checkerfield]) {
			this.form['subscriptions'].push(this.form.controls[this.to.checkerfield].valueChanges
				.subscribe((checkervalue: any) => {
					if (this.model && this.model[this.key])
						if (!(PlatformApp.validateValue(this.model[this.key], checkervalue, this.to.operation)))
							this.setFormError('validateError');
				}));
		}
	}

	private setFormError(errorKey) {
		let error = {};
		error[errorKey] = true;
		this.form['formValidity'] = false;
		if (this.form.controls[this.key]) {
			this.form.controls[this.key].markAsTouched();
			this.form.controls[this.key].setErrors(error);
		}
	}
	private addWatcher(formControl) {
		this.form['subscriptions'].push(formControl.valueChanges
			.subscribe((updatedValue: any) => {
				this.processFormulae(updatedValue);
			}));
	}

	private processFormulae(currentValue) {
		for (var i = 0; i < this.formulae.length; i++) {
			var formula = this.formulae[i];
			if (this.setModelValues(formula['fields'], currentValue)) {
				this.setResults(formula['results'], PlatformApp.processData(formula['formula'], this.modelValues));
			}
		}
	}

	private setModelValues(fieldnames: Array<any>, updatedValue: any) {
		let valid = true;
		this.modelValues = [];
		fieldnames.forEach((fieldname) => {
			if (!this.model[fieldname]) {
				valid = false;
			} else {
				if (fieldname == this.field.key)
					this.modelValues.push(updatedValue);
				else
					this.modelValues.push(this.model[fieldname]);
			}
		});
		return valid;
	}

	private setResults(fieldnames: Array<any>, value: any): void {
		fieldnames.forEach((fieldname) => {
			if (this.form.controls[fieldname]) {
				this.form.controls[fieldname].setValue(value);

				if (this.form['newcontrols'][fieldname] && !this.model[fieldname]) {
					this.form.setControl(fieldname, this.form['newcontrols'][fieldname]);
					this.form.controls[fieldname].setValue(value);
				}
			} else {
				if (this.form['newcontrols'][fieldname]) {
					this.form.addControl(fieldname, this.form['newcontrols'][fieldname]);
					this.form.controls[fieldname].setValue(value);
				} else
					this.model[fieldname] = value;
			}
		});
	}
	private getFormField(fieldname: string, formfields: Array<any>) {
		let field: any;
		formfields.forEach((formField) => {
			if (fieldname === formField.key)
				field = formField;
		});
		return field;
	}

	private getFilterSelectOptions(formfields: Array<any>) {
		let optionFields = [];
		if (formfields)
			formfields.forEach(function (field) {
				if (field.type !== 'repeatedsection')
					optionFields.push({ value: field.key, label: field.templateOptions.label.replace('*', '') });
			});
		return _.sortBy(optionFields, 'label');
	}

	private constructFilterOptions(formField: any) {
		let fieldType = formField.type;
		let fieldSubType = formField.templateOptions.type;

		// Handle unique cases first
		if (fieldType === 'date' || fieldType === 'dateandtime' || fieldSubType === 'date' || fieldSubType === 'dateandtime') {
			this.setFilterType('date');
		} else if (fieldSubType === 'number' || fieldSubType === 'percent' || fieldSubType === 'currency') {
			this.setFilterType('number');
		} else {
			switch (fieldType) {
				case 'input-field':
				case 'time':
				case 'geolocation':
				case 'textarea':
					this.setFilterType('text');
					break;

				case 'checkbox':
					this.setFilterType('boolean');
					break;

				case 'select-component':
					this.setFilterType('select');
					this.model['filterValueLabel'] = formField.templateOptions.label.replace('*', '');
					this.model['filterValueType'] = formField.templateOptions.type;
					for (var key in formField)
						if (formField.hasOwnProperty(key))
							if (key !== "key" && key !== "type" && key !== "templateOptions" && key !== "hideExpression" && key !== "expressionProperties")
								this.model[key] = formField[key];
					break;

				case 'default':
					this.setFilterType('text');
					break;

			}
		}
	}

	private setFilterType(filtertype: string) {

		switch (filtertype) {
			case 'date':
				this.model['filtertype'] = 'select';
				this.model['filterValueType'] = 'date';
				this.model['filterValueLabel'] = 'Choose Value';
				this.model['filterConditionOptions'] = this.getFilterConditionOptions('date');
				this.model['filterValueOptions'] = this.getFilterValueOptions('date');
				break;

			case 'number':
				this.model['filtertype'] = 'input';
				this.model['filterValueType'] = 'number';
				this.model['filterValueLabel'] = 'Enter Value';
				this.model['filterConditionOptions'] = this.getFilterConditionOptions('number');
				this.model['filterValueOptions'] = [];
				break;

			case 'text':
				this.model['filtertype'] = 'input';
				this.model['filterValueType'] = 'text';
				this.model['filterValueLabel'] = 'Enter Value';
				this.model['filterConditionOptions'] = this.getFilterConditionOptions('text');
				this.model['filterValueOptions'] = [];
				break;

			case 'boolean':
				this.model['filtertype'] = 'select';
				this.model['filterValueType'] = 'boolean';
				this.model['filterValueLabel'] = 'Choose Value';
				this.model['filterConditionOptions'] = this.getFilterConditionOptions('boolean');
				this.model['filterValueOptions'] = this.getFilterValueOptions('boolean');
				break;

			case 'select':
				this.model['filtertype'] = 'select';
				this.model['filterConditionOptions'] = this.getFilterConditionOptions('boolean');
				this.model['filterValueOptions'] = [];
				break;

			default:
				this.model['filtertype'] = 'input';
				this.model['filterValueType'] = 'text';
				this.model['filterValueLabel'] = 'Enter Value';
				this.model['filterConditionOptions'] = this.getFilterConditionOptions('text');
				this.model['filterValueOptions'] = [];
				break;
		}
	}

	private getFilterConditionOptions(filtertype: string) {
		let options: any = [];

		switch (filtertype) {
			case 'number':
				options = [
					{ 'label': 'equals', 'value': 'equals' },
					{ 'label': 'is less than', 'value': 'is less than' },
					{ 'label': 'is greater than', 'value': 'is greater than' },
					{ 'label': 'is between', 'value': 'is between' }
				];
				break;

			case 'boolean':
				options = [
					{ 'label': 'equals to', 'value': 'equals to' },
					{ 'label': 'not equals to', 'value': 'not equals to' }
				];
				break;

			case 'date':
				options = [
					{ 'label': 'is', 'value': 'is' },
					{ 'label': 'is before', 'value': 'is before' },
					{ 'label': 'is after', 'value': 'is after' },
					{ 'label': 'is between', 'value': 'is between' }
				];
				break;

			default:
				options = [
					{ 'label': 'contains', 'value': 'contains' },
					{ 'label': 'equals', 'value': 'equals' },
					{ 'label': "doesn't contain", 'value': 'does not contain' }
				];
				break;
		}
		return options;
	}

	private getFilterValueOptions(filtertype: string) {
		let values: any = [];

		switch (filtertype) {
			case 'boolean':
				values = [
					{ 'label': 'True', 'value': '1' },
					{ 'label': 'False', 'value': '0' }
				];
				break;

			case 'date':
				values = [
					{ 'label': 'Today', 'value': 'today' },
					{ 'label': 'Yesterday', 'value': 'yesterday' },
					{ 'label': 'This Week', 'value': 'thisweek' },
					{ 'label': 'Next Week', 'value': 'nextweek' },
					{ 'label': 'Last 7 Days', 'value': 'last7days' },
					{ 'label': 'Last Week', 'value': 'lastweek' },
					{ 'label': 'This Month', 'value': 'thismonth' },
					{ 'label': 'Next Month', 'value': 'nextmonth' },
					{ 'label': 'Last Month', 'value': 'lastmonth' }
				];
				break;

			default:
				values = [];
				break;
		}
		return values;
	}

	ngOnDestroy() {
		this.selectedvalues = [];
		this.items = [];
	}

	public selected(value: any): void {
		if (this.multiple) {
			if (value && value.id)
				if (this.model[this.key] && this.model[this.key].length)
					this.model[this.key].push(value.id);
				else
					this.model[this.key] = [value.id];
		}
		else
			if (value && value.id) {
				this.formControl.setValue(value.id);
				if (value.text && this.field.templateOptions.filtering)
					this.model[this.key + '_label'] = value.text;
			}

		for (var key in this.form['newcontrols'])
			this.setNewFormControl(key);
	}

	public removed(value: any): void {
		if (this.multiple) {
			if (value && value.id)
				if (this.model[this.key] && this.model[this.key].length)
					this.model[this.key].splice(this.model[this.key].indexOf(value.id), 1);
		}
		else
			this.resetSelection();
	}

	public typed(value: any): void {
	}

	public refreshValue(value: any): void {
		this.value = value;
	}

	private getValue(field: any, subfield: string) {
		if (field['templateOptions'] && field['templateOptions'][subfield])
			return field['templateOptions'][subfield];
		if (field['expressionProperties'] && (field['expressionProperties'].hasOwnProperty(subfield)))
			return evalExpression(field['expressionProperties'][subfield].expression, this, [this.model, this.options.fromState]);
		if (field[subfield])
			return field[subfield];
		return null;
	}

	private setNewFormControl(fieldname: string) {
		if (this.form['newcontrols'][fieldname])
			if (!this.form.controls[fieldname])
				this.form.addControl(fieldname, this.form['newcontrols'][fieldname]);
			else
				this.form.setControl(fieldname, this.form['newcontrols'][fieldname]);
		else
			console.log('Error !!! No Form Control for Field: "' + fieldname + '" in select-component of "' + this.key + '"');
	}

	private addNewRecord() {
		console.log('New Entity Record Creation - Yet to be Implemented');
	}
	private resetSelection() {
		if (this.model[this.key])
			delete this.model[this.key];
		this.selectedvalues = [];
		this.formControl.reset();
	}
	private viewRecord() {
		console.log('View - Yet to be Implemented');
	}
}




// WEBPACK FOOTER //
// ./src/app/shared/components/fields/radiopicklist.ts